module.exports = __webpack_public_path__ + "static/media/Circo2024_09.566694c6.webp";